import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download_staging/69f2533c63911b00146ef13b_1781335730274_c416bd25/votly/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModulesProvider"] */ "/home/ubuntu/download_staging/69f2533c63911b00146ef13b_1781335730274_c416bd25/votly/src/contexts/ModulesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LangProvider"] */ "/home/ubuntu/download_staging/69f2533c63911b00146ef13b_1781335730274_c416bd25/votly/src/lib/langContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69f2533c63911b00146ef13b_1781335730274_c416bd25/votly/src/styles/tailwind.css");
